//for IE, Edge polyfill
import smoothscroll from 'smoothscroll-polyfill';
import ScrollOut from "scroll-out";

smoothscroll.polyfill();

window.addEventListener("load", onNovelLoadHandler, false);

function onNovelClickNextHandler(e){
  e.preventDefault();
  var scroller = document.getElementById('novel_scroller');
  scroller.scrollBy({
    top: 0, left: -window.innerWidth,
    behavior: 'smooth'
  });
}
function onNovelClickPrevHandler(e){
  e.preventDefault();
  var scroller = document.getElementById('novel_scroller');
  scroller.scrollBy({
    top: 0, left: window.innerWidth,
    behavior: 'smooth'
  });
}

function onNovelDragHandler(e){
  if(e.screenX === 0) return;
  e.preventDefault();
  var scroller = document.getElementById('novel_scroller');
  var container = document.getElementById('novel_container');
  var screen_position = e.clientX / window.innerWidth; //マウスの位置から見たスクロールの位置（割合）
  scroller.scroll({
    top: 0, left: container.clientWidth * (screen_position * 0.8 + 0.1)
  });
}

function disableScrollHandler(e){
  e.preventDefault();
  return false;
}
function moveScrollHandler(e){
  e.preventDefault();
  var scroller = document.getElementById('novel_scroller');
  var container = document.getElementById('novel_container');
  var scrollbar = document.getElementById('novel_scroll_current');
  var screen_raito = window.innerWidth / container.clientWidth; //コンテンツと画面の割合
  var scroll_position = scroller.scrollLeft / (container.clientWidth - window.innerWidth); //スクロールの位置（割合）
  var scrollbar_right = 1 - scroll_position; //反転
  var scrollbar_width = window.innerWidth * screen_raito * 0.8;
  scrollbar.style.width = scrollbar_width + 'px';
  scrollbar.style.right = 'calc(' + ( scrollbar_right * 100 ) + '% - ' + ( scrollbar_width * scrollbar_right ) + 'px)';
}

function changeDirectionWheelHandler(e){
  var scroller = document.getElementById('novel_scroller');
  scroller.scrollTop = 0;
  scroller.scrollLeft += -e.deltaY + e.deltaX;
  e.preventDefault();
}

function onKeyboardUpHandler(e){
  var scroller = document.getElementById('novel_scroller');
  var distance = 0;
  switch (e.key) {
    case 'ArrowUp':
    case 'ArrowRight':
      distance = window.innerWidth;
    break;
    case 'ArrowDown':
    case 'ArrowLeft':
      distance = -window.innerWidth;
    break;
  }
  scroller.scrollBy({
    top: 0, left: distance,
    behavior: 'smooth'
  });
}

function toTopForNovel(target,left){
  target.scroll({ top:0, left:left });
}
function onResizeNovelHeight(){
  document.body.style.height = window.innerHeight + 'px';
}
function setScrollOut(){

  var scrollout_config = {
    scrollingElement: ".novel-scroller",
  }
  scrollout_config.targets = '.novel-title';
  scrollout_config.onShown = function(element, ctx, scrollingElement) {
    document.body.classList.add('cover-close');
    document.body.classList.add('novel-open');
  };
  scrollout_config.onHidden = function(element, ctx, scrollingElement) {
    if(ctx.intersectX < 0){
      document.body.classList.remove('cover-close');
      document.body.classList.remove('novel-open');
    }else{
      document.body.classList.add('novel-open');
    }
  };
  ScrollOut(scrollout_config);

  scrollout_config.targets = '.novel-index';
  scrollout_config.onHidden = function(element, ctx, scrollingElement) {
    if(ctx.intersectX > 0){
      document.body.classList.remove('novel-open');
    }
  };
  ScrollOut(scrollout_config);

}

//小説
function onNovelLoadHandler(e){
  var body_classes = document.body.classList;
  if(!body_classes.contains('body-template-novel')) return this;

  var scroller = document.getElementById('novel_scroller');
  var container = document.getElementById('novel_container');
  var cover = document.getElementsByClassName('novel-header__cover');

  document.body.classList.add('loaded');

  scroller.addEventListener("scroll", disableScrollHandler, false);
  window.addEventListener("resize", onResizeNovelHeight, false);

  toTopForNovel(scroller,container.clientWidth - window.innerWidth);

  cover[0].addEventListener("transitionend", function(e) {
    window.addEventListener("keyup", onKeyboardUpHandler, false);
    scroller.removeEventListener("scroll", disableScrollHandler, false);
    scroller.addEventListener("scroll", moveScrollHandler, false);
    container.addEventListener("wheel", changeDirectionWheelHandler, false);
    toTopForNovel(scroller,container.clientWidth - window.innerWidth);
    document.getElementById('novel_scroll_next').addEventListener( 'click', onNovelClickNextHandler, false );
    document.getElementById('novel_scroll_prev').addEventListener( 'click', onNovelClickPrevHandler, false );
    document.getElementById('novel_scroll_current').addEventListener( 'drag', onNovelDragHandler, false );
    setScrollOut();
  });

}
